import { useQuery } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
function useWorkspacePermittedData(isOpen, permission, params) {
  return useQuery("workspaceData-".concat(permission), function () {
    return servicesUtils.getService("/workspaces/permitted/?permission=".concat(permission), params);
  }, {
    enabled: isOpen
  });
}
export default useWorkspacePermittedData;